<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ settings[selected]?.title }}</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical full-width-btn align-items-center" routerLink="/valet/stipendi/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical full-width-btn align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Stipendi
          </button>
        </ng-template>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="expertSalaryModel()">
          Genera Stipendi<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="exportExpertSalary()" *ngIf="groups.includes('admin') || groups.includes('operation')">
          Esporta<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <select class="btn-white full-width-btn vertical align-items-center" *ngIf="groups.includes('expert')" [disabled]="!selectedDeliveries.length" (change)="handleMultipleStatusChange($event.target.value)">
          <option value="" selected disabled>Select Status</option>
          <ng-container *ngFor="let paymentStatus of deliveryPaymentStatusAux[selected]">
            <option *ngIf="paymentStatus !== 'default'" [value]="paymentStatus">
              {{ deliveryPaymentStatusAux.ln('it', paymentStatus) }}
            </option>
          </ng-container>
        </select>

        <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleExpertChange($event)">
            <option [ngValue]="null" disabled selected>Select Valet</option>
            <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
        </select>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

      <div class="table-responsive-invoice has-margin-top" style="overflow-x: scroll; ">
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
            <form class="table-row-container row first-row filter" [formGroup]="_deliveryFilterForm" (ngSubmit)="filter()" *ngIf="_deliveryFilterForm">

                <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>

                <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>
     
                <div class="hide-on-mobile item center data-col-5">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>

                <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">STATO</h4>
                    <span class="data">
                      <select formControlName="Delivery.status">
                        <option value="">Tutti</option>
                        <option *ngFor="let dSActive of deliveryStatusAux[selected]" [value]="dSActive">
                          {{deliveryStatusAux.ln('it', dSActive)}}
                        </option>
                      </select>
                    </span>
                </div>
                
                <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">PAYMENT STATO</h4>
                    <span class="data">
                      <select formControlName="Delivery.paymentStatus">
                        <option value="">Tutti</option>
                        <option *ngFor="let paymentStatus of deliveryPaymentStatusAux[selected]" [value]="paymentStatus">
                          {{ deliveryPaymentStatusAux.ln('it', paymentStatus) }}
                        </option>
                      </select>
                    </span>
                </div>

                <div class="item data-col-{{getSpacing('id')}}">
                  <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
                    VENDITA
                  </h4>
                  <span class="data">
                    <input type="number" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
                  </span>
                </div>
             
                <div class="item data-col-{{getSpacing('id')}}">
                    <h4 class="title" (click)="navigateOrder('Delivery.id')">
                        <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
                        ID
                    </h4>
                    <span class="data">
                        <input type="number" formControlName="Delivery.id" min="1000" max="10000">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                    <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
                        DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
                    </span>
                </div>
        
                <div class="item center data-col-{{getSpacing('time')}}">
                    <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
                        ORARIO
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="time" formControlName="Delivery.fromTime">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="time" formControlName="Delivery.toTime">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                    <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                        PARTNER
                    </h4>
                    <span class="data">
                        <input type="text" formControlName="Partner.businessName"
                        class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                    <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
                        EXPERT
                    </h4>
                    <span class="data"> 
                        <input type="text" formControlName="UserExpert.surname">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('address')}}">
                    <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
                        INDIRIZZO
                    </h4>
    
                    <span class="data">
                        <input type="text" formControlName="Delivery.address">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                    <h4 class="title">INDIRIZZO DI RITIRO</h4>
                    <span class="data">
                        <input type="text" formControlName="Delivery.partner.address">
                    </span>
                </div>
    
                <div class="item data-col-30 pickUpTime">
                    <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
                        ORA RITIRO
                    </h4>
                    <span class="data">
                        <div class="date"></div>
                        <input class="date" type="time" formControlName="Delivery.pickUpTime">
                    </span>
                </div>
    
                <!--
                <div class="item data-col-30" *ngIf="groups.includes('admin')">
                    <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                        PREZZO</h4>
                    <span class="data">
                        <input type="text" formControlName="Delivery.price">
                    </span>
                </div>

                <div class="item data-col-30" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                    PLUS MINUS PREZZO</h4>
                  <span class="data">
                    <input type="text" formControlName="Delivery.additionalPrice">
                  </span>
                </div>

                <div class="item data-col-30" >
                    <h4 class="title" (click)="navigateOrder(['Delivery.expertSalary', 'Delivery.expertSalary'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.expertSalary', 'Delivery.expertSalary'])"></i>
                        VALET SALARIO</h4>
                    <span class="data">
                        <input type="text" formControlName="Delivery.expertSalary">
                    </span>
                </div>

                <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                    <h4 class="title" (click)="navigateOrder(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])"></i>
                        PLUS MINUS PRICE STIPENDI</h4>
                    <span class="data">
                        <input type="text" formControlName="Delivery.valetAdditionalPrice">
                    </span>
                </div>
                -->

                <div class="item center data-col-5">
                    <h4 class="title">SERVIZIO TYPE</h4>
                    <span class="data">
                        <select formControlName="Delivery.serviceType">
                        <option [selected]="true" [disabled]="true">Service Type</option>
                        <option value="sales">Servizi Vendita</option>
                        <option value="hourlyrate">Servizi a Ora</option>
                        <option value="fixedprice">Servizi a Prezzo Fisso</option>
                        <option value="corporate">Servizio Aziendale</option>
                        <option value="warehouseservice">Servizio Magazzino</option>
                        </select>
                    </span>
                </div>

                <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <h4 class="title">DA PAGARE</h4>
                  <span class="data">
                    <select formControlName="Delivery.payable" style="width: 120px;">
                      <option value="">Tutti</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </span>
                </div>

                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                    <h4 class="title" (click)="navigateOrder('RefundRequests.createdAt')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('RefundRequests.createdAt')"></i>
                        REFUND DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="RefundRequests.createdFrom">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="RefundRequests.createdTo">
                    </span>
                </div>

                <div class="item data-col-5" >
                    <h4 class="title" (click)="navigateOrder(['RefundRequests.plusValue', 'RefundRequests.plusValue'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['RefundRequests.plusValue', 'RefundRequests.plusValue'])"></i>
                        REFUND PLUS</h4>
                    <span class="data">
                        <input type="text" formControlName="RefundRequests.plusValue">
                    </span>
                </div>

                <div class="item data-col-30" *ngIf="groups.includes('admin')">
                  <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                      PREZZO</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.price">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  PLUS MINUS PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item data-col-30" >
                  <h4 class="title" (click)="navigateOrder(['Delivery.expertSalary', 'Delivery.expertSalary'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.expertSalary', 'Delivery.expertSalary'])"></i>
                      VALET SALARIO</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.expertSalary">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <h4 class="title" (click)="navigateOrder(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])"></i>
                      PLUS MINUS PRICE STIPENDI</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.valetAdditionalPrice">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <h4 class="title" (click)="navigateOrder(['Delivery.payAtDeliveryAmount', 'Delivery.payAtDeliveryAmount'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.payAtDeliveryAmount', 'Delivery.payAtDeliveryAmount'])"></i>
                      INCASSI CONTANTI</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.payAtDeliveryAmount">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                <h4 class="title" (click)="navigateOrder(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])"></i>
                    TOTALE</h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.valetAdditionalPrice">
                </span>
              </div>
      
              <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container">
                  <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i></button>
                    <br/>
                  <button class="btn vertical align-items-center" (click)="fnReset();">
                    RESET <i class="fas fa-times-circle"></i></button>
                </span>
              </div>
            </form>

            <div class="table-row-container row" *ngIf="deliveries.length">
                <div class="select-all">
                  <input type="checkbox" id="checkAll" style="cursor: pointer;" [checked]="selectedDeliveries.length === deliveries.length" (change)="selectAllDeliveries()" />
                  <label for="checkAll" style="cursor: pointer;">Seleziona Tutti</label>
                </div>
            </div>

            <div class="table-row-container row" *ngFor="let delivery of deliveries">

                <div class="item data-col-5">
                    <span class="data-row-left"> <br>
                        <input type="checkbox" style="cursor: pointer;"  [id]="'checkbox_' + delivery.id" [checked]="isSelected(delivery)" (change)="toggleSelection(delivery)" />
                    </span>
                </div>

                <div class="item data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                  <span class="data-row-left">
                    <a *ngIf="groupWhitelisted('admin')">
                      <span class="green-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByPartner != null">
                        <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                      </span>
                      <span class="blue-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByExpert != null">
                        <i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;
                      </span>
                    </a>
                  </span>
                </div>
      
                <div class="item center data-col-5">
                  <h4 class="title">&nbsp;</h4>
                  <img class="service-img" [src]="showServiceDetails(delivery?.service)?.image" width="40" height="40" *ngIf="showServiceDetails(delivery?.service)?.image">
                </div>
      
                <div class="item left-space center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                  <span class="data-row-left">
                    <h4 class="title">STATO :</h4>
                    <a [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                      <span class="dataGesture">
                        <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                        {{deliveryStatusAux.ln('it', delivery.status)}}
                      </span>
                    </a>
                  </span>
                </div>         

                <div class="item data-col-{{getSpacing('expert')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">PAYMENT STATUS :</h4>
                    <a class="badge">
                      <mat-chip [matTooltip]="showFinancialStatus(delivery)" class="chip" [class]="deliveryPaymentStatusClass(delivery)">{{ showFinancialStatus(delivery) }}</mat-chip>
                    </a>
                  </span>
                </div>

                <div class="item center data-col-{{getSpacing('id')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">VENDITA:</h4>
                    <a>
                      <!-- {{ delivery?.orderId | saleName: delivery?.shop }} -->
                      <!-- {{ 
                        (
                          delivery?.orderId && delivery?.externalOrderSource
                        ) ? 'M' + delivery.orderId
                          : (
                            delivery?.orderId && !delivery?.externalOrderSource
                          ) ? (delivery.orderId | saleName: delivery.shop)
                            : (
                              delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource
                            ) ? delivery.ddtNumber
                              : '---'
                      }} -->

                      <!-- {{ 
                        (delivery?.orderId && delivery?.externalOrderSource) 
                          ? 'M' + delivery.orderId 
                          : (
                              delivery?.ddtNumber && !delivery?.externalOrderSource
                            ) 
                              ? (delivery.ddtNumber | saleName: delivery.shop : delivery.ddtNumber) 
                              : '---' 
                      }}   -->

                      {{
                        delivery.correspondDelivery
                          ? delivery.correspondDelivery
                          : (delivery?.orderId && delivery?.externalOrderSource)
                            ? 'M' + delivery.orderId
                            : (delivery?.ddtNumber && !delivery?.externalOrderSource)
                              ? ((delivery.ddtNumber | saleName: delivery.shop) || delivery.ddtNumber)
                              : '---'
                      }}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('id')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">ID :</h4>
                    <a>
                      {{delivery.id}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">DATA :</h4>
                    <a>
                      {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
                    </a>
                  </span>
                </div>
      
                <div class="item center data-col-{{getSpacing('time')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">ORARIO :</h4>
                    <a *ngIf="delivery.toTime != null">{{formatTimeShow(delivery.fromTime, delivery.toTime)}}</a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">PARTNER :</h4>
                    <a>
                      {{delivery.partner?.businessName}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">EXPERT :</h4>
                    <a>
                      {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('address')}}">
                  <span class="data-row-left tick">
                    <h4 class="title table-title">INDIRIZZO :</h4>
                    <a>
                      {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                  <span class="data-row-left">
                    <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
                    <a>
                      {{delivery.partner?.address || "---"}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-30 pickUpTime">
                  <span class="data-row-left">
                    <h4 class="title table-title">ORA RITIRO :</h4>
                    <a>
                      {{ delivery?.pickUpTime || "---"}}
                    </a>
                  </span>
                </div>

                <!--
                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PREZZO:</h4>
                    <a>
                      {{ delivery?.price || "0"}}€
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      {{ delivery?.additionalPrice || "0"}}€
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime">
                  <span class="data-row-left">
                    <h4 class="title table-title">VALET SALARIO:</h4>
                    <a>
                      {{
                        delivery?.payable
                          ? (delivery?.expertSalary || "0") + "€"
                          : ("0 €")
                      }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      {{ delivery?.valetAdditionalPrice || "0"}}€
                    </a>
                  </span>
                </div>
                -->

                <div class="item left-space data-col-5">
                  <span class="data-row-left">
                    <h4 class="title">SERVIZIO TYPE :</h4>
                    <a>
                      {{ delivery?.serviceType | serviceName }}  
                    </a>
                  </span>
                </div>

                <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <span class="data-row-left">
                    <h4 class="title">DA PAGARE :</h4>
                    <a>
                     {{
                      delivery?.payable ? "Yes" : "No"
                     }}        
                    </a>
                  </span>
                </div>

                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">REFUND DATA :</h4>
                    <a>
                      {{ delivery?.refundRequest ? (delivery.refundRequest.createdAt | date:'dd/MM/yyyy') : '---' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-5">
                  <span class="data-row-left">
                    <h4 class="title table-title">REFUND PLUS:</h4>
                    <a>
                      <!--
                      {{
                        delivery?.refundRequest
                          ? (delivery.refundRequest.plusValue || "0") + "€"
                          : "---"
                      }}
                      -->
                      {{ commanForValues(delivery).refundPlus | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PREZZO:</h4>
                    <a>
                      <!-- {{ (delivery?.price || 0) | currency:'EUR' }} -->
                      {{ commanForValues(delivery).prezzo | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      <!-- {{ delivery?.additionalPrice || "0"}}€ -->
                      {{ commanForValues(delivery).plusMinusPrezzo | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime">
                  <span class="data-row-left">
                    <h4 class="title table-title">VALET SALARIO:</h4>
                    <a>
                      <!--
                      {{
                        delivery?.payable
                          ? (delivery?.expertSalary || "0") + "€"
                          : ("0 €")
                      }}
                      -->
                      {{ commanForValues(delivery).valetSalary | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      <!--
                       {{
                        delivery?.payable
                          ? ((delivery?.valetAdditionalPrice || 0) | currency:'EUR')
                          : ("0 €")
                      }}
                      -->
                      {{ commanForValues(delivery).valetPlusMinusSalary | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">INCASSI CONTANTI:</h4>
                    <a>
                      {{ (delivery?.payAtDeliveryAmount || 0) | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">TOTALE:</h4>
                    <a>
                      {{ commanForValues(delivery).totale | currency:'EUR' }}
                    </a>
                  </span>
                </div>                

                <div class="item nowrap">
                  <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id]">DETTAGLI</button>
                    <!-- <button class="btn vertical align-items-center" (click)="complainForDeliverySalary(delivery)" *ngIf="groupWhitelisted(['expert']) && delivery?.deliveryComplaints.some((complaint) => complaint?.expert?.id === selectedExpert?.id)" [disabled]="disableBtn">RECLAMA</button> -->
                    <button 
                        class="btn vertical align-items-center" 
                        (click)="complainForDeliverySalary(delivery)" 
                        *ngIf="groupWhitelisted(['expert']) && !delivery?.sendToExpert && !complaintAlredayRegistered(delivery)" 
                        [disabled]="disableBtn">
                        RECLAMA
                    </button>
                    <button class="btn vertical align-items-center" (click)="requestSalaryRefund(delivery)" *ngIf="groupWhitelisted(['expert']) && !delivery?.refundRequest" [disabled]="disableBtn">AGGIUNGI</button>
                    <a target="_blank" class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted(['admin', 'operation'])">MODIFICA</a>
                    <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'delivered' || delivery.status == 'notDelivered')">MODIFICA</button>
                    <button (click)="handleModalBox(delivery.id)" *ngIf="groupWhitelisted(['admin', 'operation'])" class="btn vertical align-items-center" >Additional Valet +/-</button>
                  </span>
                </div>

            </div>

            
            <div class="table-row-container row total-row" *ngIf="deliveries.length">
              <div class="item data-col-5">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>TOTALE</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>---</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.refundPlus | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted(['admin', 'operation'])">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.prezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted(['admin', 'operation'])">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.plusMinusPrezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valetSalary | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valetPlusMinusSalary | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.payAtDeliveryAmount | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.totale | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>
            
            </div>
        </div>
      </div>
    </section>
  </div>
</section>

<div *ngIf="showAddionalPriceValetModal" class="amp-backdrop">
  <div class="amp-box">

    <div class="amp-header">
      <h3 class="amp-title">Inserisci valore</h3>
    </div>

    <div class="amp-body">
      <label class="amp-label">Valore aggiuntivo valet (+ / -)</label>

      <input
        type="number"
        [(ngModel)]="additionalValetPlusMinus"
        class="amp-input"
        placeholder="Inserisci numero"
        [disabled]="isSubmitting"
      />
    </div>

    <div class="amp-footer">
      <button
        class="amp-btn"
        (click)="submitAdditionalValetPlusMinus()"
        [disabled]="isSubmitting"
      >
        <ng-container *ngIf="!isSubmitting">
          Aggiungi
        </ng-container>

        <ng-container *ngIf="isSubmitting">
          <span class="amp-spinner"></span>
          Caricamento...
        </ng-container>
      </button>

      <button
        class="amp-btn amp-btn--secondary"
        (click)="handleModalBox()"
      >
        Chiudi
      </button>
    </div>

  </div>
</div>

<!--
<section class="title-bar content-padding first-item">

  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ settings[selected]?.title }}</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical full-width-btn align-items-center" routerLink="/valet/stipendi/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical full-width-btn align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Stipendi
          </button>
        </ng-template>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="expertSalaryModel()">
          Genera Stipendi<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="exportExpertSalary()" *ngIf="groups.includes('admin') || groups.includes('operation')">
          Esporta<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <select class="btn-white full-width-btn vertical align-items-center" *ngIf="groups.includes('expert')" [disabled]="!selectedDeliveries.length" (change)="handleMultipleStatusChange($event.target.value)">
          <option value="" selected disabled>Select Status</option>
          <ng-container *ngFor="let paymentStatus of deliveryPaymentStatusAux[selected]">
            <option *ngIf="paymentStatus !== 'default'" [value]="paymentStatus">
              {{ deliveryPaymentStatusAux.ln('it', paymentStatus) }}
            </option>
          </ng-container>
        </select>

      </span>
    </div>
  </div>

  <div class="wrapper nowrap">
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <div class="vertical full-width-btn align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label for="">Valet</label>
          <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleExpertChange($event)">
              <option [ngValue]="null" disabled selected>Select Valet</option>
              <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
          </select>
        </div>
      </span>
    </div>
  </div>
  
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="table-responsive-invoice has-margin-top" style="overflow-x: scroll; ">
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
            <form class="table-row-container row first-row filter" [formGroup]="_deliveryFilterForm" (ngSubmit)="filter()" *ngIf="_deliveryFilterForm">

                <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>

                <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>
     
                <div class="hide-on-mobile item center data-col-5">
                    <h4 class="title">&nbsp;</h4>
                    <span class="data"> &nbsp; </span>
                </div>

                <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">STATO</h4>
                    <span class="data">
                      <select formControlName="Delivery.status">
                        <option value="">Tutti</option>
                        <option *ngFor="let dSActive of deliveryStatusAux[selected]" [value]="dSActive">
                          {{deliveryStatusAux.ln('it', dSActive)}}
                        </option>
                      </select>
                    </span>
                </div>
                
                <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                    <h4 class="title">PAYMENT STATO</h4>
                    <span class="data">
                      <select formControlName="Delivery.paymentStatus">
                        <option value="">Tutti</option>
                        <option *ngFor="let paymentStatus of deliveryPaymentStatusAux[selected]" [value]="paymentStatus">
                          {{ deliveryPaymentStatusAux.ln('it', paymentStatus) }}
                        </option>
                      </select>
                    </span>
                </div>

                <div class="item data-col-{{getSpacing('id')}}">
                  <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
                    VENDITA
                  </h4>
                  <span class="data">
                    <input type="number" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
                  </span>
                </div>
             
                <div class="item data-col-{{getSpacing('id')}}">
                    <h4 class="title" (click)="navigateOrder('Delivery.id')">
                        <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
                        ID
                    </h4>
                    <span class="data">
                        <input type="number" formControlName="Delivery.id" min="1000" max="10000">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                    <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
                        DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
                    </span>
                </div>
        
                <div class="item center data-col-{{getSpacing('time')}}">
                    <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
                        ORARIO
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="time" formControlName="Delivery.fromTime">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="time" formControlName="Delivery.toTime">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                    <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                        PARTNER
                    </h4>
                    <span class="data">
                        <input type="text" formControlName="Partner.businessName"
                        class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                    <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
                        EXPERT
                    </h4>
                    <span class="data"> 
                        <input type="text" formControlName="UserExpert.surname">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('address')}}">
                    <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
                        INDIRIZZO
                    </h4>
    
                    <span class="data">
                        <input type="text" formControlName="Delivery.address">
                    </span>
                </div>
        
                <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                    <h4 class="title">INDIRIZZO DI RITIRO</h4>
                    <span class="data">
                        <input type="text" formControlName="Delivery.partner.address">
                    </span>
                </div>
    
                <div class="item data-col-30 pickUpTime">
                    <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
                        ORA RITIRO
                    </h4>
                    <span class="data">
                        <div class="date"></div>
                        <input class="date" type="time" formControlName="Delivery.pickUpTime">
                    </span>
                </div>

                <div class="item center data-col-5">
                    <h4 class="title">SERVIZIO TYPE</h4>
                    <span class="data">
                        <select formControlName="Delivery.serviceType">
                        <option [selected]="true" [disabled]="true">Service Type</option>
                        <option value="sales">Servizi Vendita</option>
                        <option value="hourlyrate">Servizi a Ora</option>
                        <option value="fixedprice">Servizi a Prezzo Fisso</option>
                        <option value="corporate">Servizio Aziendale</option>
                        <option value="warehouseservice">Servizio Magazzino</option>
                        </select>
                    </span>
                </div>

                <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <h4 class="title">DA PAGARE</h4>
                  <span class="data">
                    <select formControlName="Delivery.payable" style="width: 120px;">
                      <option value="">Tutti</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </span>
                </div>

                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                    <h4 class="title" (click)="navigateOrder('RefundRequests.createdAt')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('RefundRequests.createdAt')"></i>
                        REFUND DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="RefundRequests.createdFrom">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="RefundRequests.createdTo">
                    </span>
                </div>

                <div class="item data-col-5" >
                    <h4 class="title" (click)="navigateOrder(['RefundRequests.plusValue', 'RefundRequests.plusValue'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['RefundRequests.plusValue', 'RefundRequests.plusValue'])"></i>
                        REFUND PLUS</h4>
                    <span class="data">
                        <input type="text" formControlName="RefundRequests.plusValue">
                    </span>
                </div>

                <div class="item data-col-30" *ngIf="groups.includes('admin')">
                  <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                      PREZZO</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.price">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  PLUS MINUS PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item data-col-30" >
                  <h4 class="title" (click)="navigateOrder(['Delivery.expertSalary', 'Delivery.expertSalary'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.expertSalary', 'Delivery.expertSalary'])"></i>
                      VALET SALARIO</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.expertSalary">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <h4 class="title" (click)="navigateOrder(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])"></i>
                      PLUS MINUS PRICE STIPENDI</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.valetAdditionalPrice">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <h4 class="title" (click)="navigateOrder(['Delivery.payAtDeliveryAmount', 'Delivery.payAtDeliveryAmount'])">
                      <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.payAtDeliveryAmount', 'Delivery.payAtDeliveryAmount'])"></i>
                      INCASSI CONTANTI</h4>
                  <span class="data">
                      <input type="text" formControlName="Delivery.payAtDeliveryAmount">
                  </span>
              </div>

              <div class="item data-col-30" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                <h4 class="title" (click)="navigateOrder(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.valetAdditionalPrice', 'Delivery.valetAdditionalPrice'])"></i>
                    TOTALE</h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.valetAdditionalPrice">
                </span>
              </div>
      
              <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container">
                  <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i></button>
                    <br/>
                  <button class="btn vertical align-items-center" (click)="fnReset();">
                    RESET <i class="fas fa-times-circle"></i></button>
                </span>
              </div>
            </form>

            <div class="table-row-container row" *ngIf="deliveries.length">
                <div class="select-all">
                  <input type="checkbox" id="checkAll" style="cursor: pointer;" [checked]="selectedDeliveries.length === deliveries.length" (change)="selectAllDeliveries()" />
                  <label for="checkAll" style="cursor: pointer;">Seleziona Tutti</label>
                </div>
            </div>

            <div class="table-row-container row" *ngFor="let delivery of deliveries">

                <div class="item data-col-5">
                    <span class="data-row-left"> <br>
                        <input type="checkbox" style="cursor: pointer;"  [id]="'checkbox_' + delivery.id" [checked]="isSelected(delivery)" (change)="toggleSelection(delivery)" />
                    </span>
                </div>

                <div class="item data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                  <span class="data-row-left">
                    <a *ngIf="groupWhitelisted('admin')">
                      <span class="green-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByPartner != null">
                        <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                      </span>
                      <span class="blue-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByExpert != null">
                        <i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;
                      </span>
                    </a>
                  </span>
                </div>
      
                <div class="item center data-col-5">
                  <h4 class="title">&nbsp;</h4>
                  <img class="service-img" [src]="showServiceDetails(delivery?.service)?.image" width="40" height="40" *ngIf="showServiceDetails(delivery?.service)?.image">
                </div>
      
                <div class="item left-space center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                  <span class="data-row-left">
                    <h4 class="title">STATO :</h4>
                    <a [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                      <span class="dataGesture">
                        <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                        {{deliveryStatusAux.ln('it', delivery.status)}}
                      </span>
                    </a>
                  </span>
                </div>         

                <div class="item data-col-{{getSpacing('expert')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">PAYMENT STATUS :</h4>
                    <a class="badge">
                      <mat-chip [matTooltip]="showFinancialStatus(delivery)" class="chip" [class]="deliveryPaymentStatusClass(delivery)">{{ showFinancialStatus(delivery) }}</mat-chip>
                    </a>
                  </span>
                </div>

                <div class="item center data-col-{{getSpacing('id')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">VENDITA:</h4>
                    <a>
                      {{
                        delivery.correspondDelivery
                          ? delivery.correspondDelivery
                          : (delivery?.orderId && delivery?.externalOrderSource)
                            ? 'M' + delivery.orderId
                            : (delivery?.ddtNumber && !delivery?.externalOrderSource)
                              ? ((delivery.ddtNumber | saleName: delivery.shop) || delivery.ddtNumber)
                              : '---'
                      }}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('id')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">ID :</h4>
                    <a>
                      {{delivery.id}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">DATA :</h4>
                    <a>
                      {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
                    </a>
                  </span>
                </div>
      
                <div class="item center data-col-{{getSpacing('time')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title">ORARIO :</h4>
                    <a *ngIf="delivery.toTime != null">{{formatTimeShow(delivery.fromTime, delivery.toTime)}}</a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">PARTNER :</h4>
                    <a>
                      {{delivery.partner?.businessName}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">EXPERT :</h4>
                    <a>
                      {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('address')}}">
                  <span class="data-row-left tick">
                    <h4 class="title table-title">INDIRIZZO :</h4>
                    <a>
                      {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                  <span class="data-row-left">
                    <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
                    <a>
                      {{delivery.partner?.address || "---"}}
                    </a>
                  </span>
                </div>
      
                <div class="item data-col-30 pickUpTime">
                  <span class="data-row-left">
                    <h4 class="title table-title">ORA RITIRO :</h4>
                    <a>
                      {{ delivery?.pickUpTime || "---"}}
                    </a>
                  </span>
                </div>

                <div class="item left-space data-col-5">
                  <span class="data-row-left">
                    <h4 class="title">SERVIZIO TYPE :</h4>
                    <a>
                      {{ delivery?.serviceType | serviceName }}  
                    </a>
                  </span>
                </div>

                <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert'])">
                  <span class="data-row-left">
                    <h4 class="title">DA PAGARE :</h4>
                    <a>
                     {{
                      delivery?.payable ? "Yes" : "No"
                     }}        
                    </a>
                  </span>
                </div>

                <div class="item data-col-{{getSpacing('deliveryDate')}}">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">REFUND DATA :</h4>
                    <a>
                      {{ delivery?.refundRequest ? (delivery.refundRequest.createdAt | date:'dd/MM/yyyy') : '---' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-5">
                  <span class="data-row-left">
                    <h4 class="title table-title">REFUND PLUS:</h4>
                    <a>
                      {{ commanForValues(delivery).refundPlus | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PREZZO:</h4>
                    <a>
                      {{ commanForValues(delivery).prezzo | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      {{ commanForValues(delivery).plusMinusPrezzo | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime">
                  <span class="data-row-left">
                    <h4 class="title table-title">VALET SALARIO:</h4>
                    <a>
                      {{ commanForValues(delivery).valetSalary | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                    <a>
                      {{ commanForValues(delivery).valetPlusMinusSalary | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">INCASSI CONTANTI:</h4>
                    <a>
                      {{ (delivery?.payAtDeliveryAmount || 0) | currency:'EUR' }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-30 pickUpTime" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">TOTALE:</h4>
                    <a>
                      {{ commanForValues(delivery).totale | currency:'EUR' }}
                    </a>
                  </span>
                </div>                

                <div class="item nowrap">
                  <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id]">DETTAGLI</button>
                    <button 
                        class="btn vertical align-items-center" 
                        (click)="complainForDeliverySalary(delivery)" 
                        *ngIf="groupWhitelisted(['expert']) && !delivery?.sendToExpert && !complaintAlredayRegistered(delivery)" 
                        [disabled]="disableBtn">
                        RECLAMA
                    </button>
                    <button class="btn vertical align-items-center" (click)="requestSalaryRefund(delivery)" *ngIf="groupWhitelisted(['expert']) && !delivery?.refundRequest" [disabled]="disableBtn">AGGIUNGI</button>
                    <a target="_blank" class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted(['admin', 'operation'])">MODIFICA</a>
                    <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'delivered' || delivery.status == 'notDelivered')">MODIFICA</button>
                    <button (click)="handleModalBox(delivery.id)" *ngIf="groupWhitelisted(['admin', 'operation'])" class="btn vertical align-items-center" >Additional Valet +/-</button>
                  </span>
                </div>

            </div>

            
            <div class="table-row-container row total-row" *ngIf="deliveries.length">
              <div class="item data-col-5">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>TOTALE</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>---</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.refundPlus | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted(['admin', 'operation'])">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.prezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted(['admin', 'operation'])">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.plusMinusPrezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valetSalary | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valetPlusMinusSalary | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.payAtDeliveryAmount | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.totale | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>
            
            </div>
        </div>
    </div>
</section>
-->

